import { c as _c } from "react/compiler-runtime";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { RealEstateDetailMobileWrapper } from "../RealEstateDetailMobileWrapper";
import { useDialogDetailsModalState } from "./DialogProvider";
import { useTranslations } from "next-intl";
export default function SheetModal() {
  const $ = _c(12);
  const {
    openModal,
    openModalId
  } = useDialogDetailsModalState();
  const t = useTranslations("modules.realEstateDetail");
  let t0;
  if ($[0] !== t) {
    t0 = t("imagesTitle");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="sr-only"><SheetTitle data-sentry-element="SheetTitle" data-sentry-source-file="DetailSheet.tsx">{t0}</SheetTitle></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== openModalId) {
    t2 = <RealEstateDetailMobileWrapper realEstateSlug={openModalId} inDialog={true} data-sentry-element="RealEstateDetailMobileWrapper" data-sentry-source-file="DetailSheet.tsx" />;
    $[4] = openModalId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <SheetContent hasClose={false} hasOverlay={false} className="w-screen h-full p-0 transition-all duration-300 overflow-hidden bg-background" data-sentry-element="SheetContent" data-sentry-source-file="DetailSheet.tsx">{t1}{t2}</SheetContent>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== openModal || $[10] !== t3) {
    t4 = <Sheet open={openModal} data-sentry-element="Sheet" data-sentry-component="SheetModal" data-sentry-source-file="DetailSheet.tsx">{t3}</Sheet>;
    $[9] = openModal;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}